import React, { Fragment, useState } from 'react'
import { Button, Col, Card, CardHeader, CardBody, FormGroup, Row, Table, Label, Input, FormFeedback } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../quoter/styleQuoters/styleTableList.css'
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';
export const TableListSearchQuoter = (props) => {

    const {
        isHovered,
        exportExcel,
        handleSearch,
        date_ini,
        date_end,
        searchQuotes,
        handleFilterValues,
        handleMouseEnter,
        handleMouseLeave,
        dataQuoter,
        loadingQuoterFilter,
        downdloadQuoter,
        loadingDownloadId,
        handleOpenPreview,
        loadingPreviewId

    } = props;
    console.log("🍑 dataQuoter", dataQuoter);

    const [createSweet] = useSweetAlert()

    const divStyle = {
        backgroundColor: isHovered ? "#1e90ff" : "#46afe5",
        borderColor: "#46afe5",
        color: "#fff",
        textAlign: "center",
        cursor: "pointer",
        padding: "8px 16px",
    };

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const header = (
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <Button
                color="success"
                onClick={exportExcel}
                size="sm"
                title="Exportar a Excel"
                className="d-flex align-items-center"
                style={{ borderRadius: "8px", fontWeight: "bold", backgroundColor: '#4CAF50', color: 'white' }}

            >
                <i className="pi pi-file-excel me-2" />
            </Button>
            <Input
                type="search"
                placeholder="Buscar....."
                onChange={handleSearch}
                className="form-control"
                style={{
                    maxWidth: "400px",
                    borderRadius: "8px",
                    padding: "6px 10px",
                    fontSize: "14px",
                }}
            />
        </div>
    );

   const copyCode = async (code) => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = code;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            document.execCommand("copy");

            textArea.remove();
        }

        createSweet("success", "success", "Código copiado", `Se copió correctamente el código: ${code}`);


    } catch (error) {
        console.error(error);

        createSweet(
            "error",
            "error",
            "Error",
            "No fue posible copiar el código."
        );
    }
};
    return (
        <Fragment>
            <br />
            <>
                <Col sm="12" className='container-global-zoom'>
                    <Row>
                        <Col sm="2" style={{ textAlign: "left" }}>
                            <Card style={{
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                border: 'none',
                                height: '100%',
                                borderRadius: '12px'
                            }}>
                                <CardHeader style={{
                                    background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                    color: 'white',
                                    padding: '15px',
                                    borderRadius: '12px 12px 0 0'
                                }}>
                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                        <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                    </h6>
                                </CardHeader>
                                <CardBody style={{ padding: '20px' }}>
                                    <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                        </Label>
                                        <Input
                                            type='date'
                                            value={date_ini}
                                            name="start_date"
                                            onChange={handleFilterValues}
                                            className='form-control'
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                padding: '10px',
                                                fontSize: '13px'
                                            }}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                        </Label>
                                        <Input
                                            type='date'
                                            value={date_end}
                                            name="end_date"
                                            onChange={handleFilterValues}
                                            className='form-control'
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                padding: '10px',
                                                fontSize: '13px'
                                            }}
                                        />
                                    </FormGroup>
                            
                                    <br />
                                    <b>Acciones</b>
                                    <br /><br />
                                    <Button
                                        onClick={() => searchQuotes()}
                                        // disabled={loading}
                                        color="primary"
                                        block
                                        outline
                                        className="mb-3"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            borderWidth: '2px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        Buscar
                                    </Button>
                                </CardBody>


                            </Card>
                        </Col>

                        <Col sm="10">
                            <div className="table-responsive">
                                <DataTable
                                    value={dataQuoter}
                                    paginator
                                    rows={10}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                            <br />
                                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>Sin cotizaciones.</p>
                                        </div>
                                    }
                                    loading={loadingQuoterFilter}
                                    rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"
                                    header={header}
                                >
                                    
                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                    <Column
                                        field="code"
                                        header="Código"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "8px"
                                                }}
                                            >
                                                <i
                                                    className="fa fa-copy"
                                                    title="Copiar código"
                                                    onClick={() => copyCode(rowData.code)}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#1d5b83",
                                                        fontSize: "14px"
                                                    }}
                                                />

                                                <span style={{ fontWeight: 700 }}>
                                                    {rowData.code}
                                                </span>
                                            </div>
                                        )}
                                    />
                                    <Column field="created_at" header="Fecha de creación"  body={(rowData) => (
                                            <span style={{ fontWeight: 600 }}>
                                                {rowData.created_at}
                                            </span>
                                        )} sortable headerStyle={headerStyle} style={cellStyle} />
                                    <Column
                                        field="client_type_text"
                                        header="Particular / Empresa"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span
                                                className={`client-type-pill ${
                                                    rowData.client_type_text === "Empresa"
                                                        ? "company"
                                                        : "person"
                                                }`}
                                            >
                                                <i
                                                    className={
                                                        rowData.client_type_text === "Empresa"
                                                            ? "icofont icofont-industries-alt-4"
                                                            : "icofont icofont-user-alt-5"
                                                    }
                                                />

                                                <strong>{rowData.client_type_text}</strong>
                                            </span>
                                        )}
                                    />
                                    <Column field="company_name" header="Nombre" headerStyle={headerStyle} style={cellStyle} body={(rowData) =>  <span style={{ fontWeight: 700 }}>{rowData.company_name ? rowData.company_name : rowData.client} </span>}/>
                                    <Column
                                        field="status"
                                        header="Estatus"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => {

                                            return (
                                                <span
                                                    className={`status-pill ${
                                                        rowData.status ? "success" : "warning"
                                                    }`}
                                                >
                                                    <i
                                                        className={
                                                            rowData.status
                                                                ? "fa fa-check-circle"
                                                                : "fa fa-clock-o"
                                                        }
                                                    />

                                                    {rowData.status
                                                        ? "Utilizado"
                                                        : "No utilizado"}
                                                </span>
                                            );
                                        }}
                                    />

                                    <Column
                                        field="used_at"
                                        header="Fecha de uso"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span style={{ fontWeight: 600 }}>
                                                {rowData.used_at}
                                            </span>
                                        )}
                                    />                                    
                                    
                                    <Column
                                        header="Acciones"
                                        headerStyle={headerStyle}
                                        style={{ ...cellStyle, textAlign: "center" }}
                                        body={(rowData) => (
                                            <div className="d-flex justify-content-center gap-2">
                                                <button
                                                    onClick={() => downdloadQuoter(rowData.id_quoter)}
                                                    title="Descargar"
                                                    disabled={loadingDownloadId === rowData.id_quoter}
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className="btn btn-danger mr-1"
                                                >
                                                    {loadingDownloadId === rowData.id_quoter ? (
                                                        <i className="fa fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i className="fa fa-file-pdf-o"></i>
                                                    )}
                                                </button>
                                                <button
                                                    onClick={() => handleOpenPreview(rowData.id_quoter)}
                                                    title="Previsualizar Cotización"
                                                    disabled={loadingPreviewId === rowData.id_quoter}
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className="btn btn-primary"
                                                >
                                                    {loadingPreviewId === rowData.id_quoter ? (
                                                        <i className="fa fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i className="icofont icofont-ui-search"></i>
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    />
                                </DataTable>
                            </div>
                        </Col>
                    </Row>

                </Col>
            </>
        
        </Fragment >
    )
}